var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:{ 'disabled': _vm.isDisabled },on:{"click":_vm.onClick}},[(_vm.isCheck)?_c('i',{staticClass:"icon-check"}):_c('div',{staticClass:"content"},[_c('i',{class:_vm.iconName}),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }